import { apiClient } from "../../../lib";

export const artefactsApi = {

    fetchArtefacts: async ({ params }: { params: any }): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const query = searchParams.toString();
        const response = await apiClient.get(`/artefact?${query}`);
        return response.data;
    },

    addArtefacts: async (payload: any): Promise<any> => {
        const response = await apiClient.post(`/artefact`, payload);
        return response.data;
    },

    editArtefacts: async (artefactId: string, payload: any): Promise<any> => {
        const response = await apiClient.put(`/artefact/${artefactId}`, payload);
        return response.data;
    },

    fetchArtefactsDetails: async (artefactId: string | null): Promise<any> => {
        const response = await apiClient.get(`/artefact/${artefactId}`);
        return response.data;
    },

    fetchArtefactsDetailsCount: async (projectId: string | undefined): Promise<any> => {
        const response = await apiClient.get(`/artefact/count`, { params: { project_id: projectId } });
        return response.data;
    }

};